@if (formControl()) {
<div class="aspect-picker form-group" [formGroup]="formGroup()!">
    <div class="search">
        <mat-form-field class="form-field">
            <input #search matInput [readonly]="$safeNavigationMigration(meta()?.readonly)" [placeholder]="meta().name"
                class="form-control input-date" [formControl]="formControl()!" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPick($event)">
                @for (group of filtered | async; track group.key) {
                <mat-optgroup [label]="group.key">
                    @for (item of group.items; track item._id) {
                    <mat-option [value]="item">
                        {{item.name}}
                    </mat-option>
                    }
                </mat-optgroup>
                }
            </mat-autocomplete>
            <mat-hint>
                <strong>{{meta().info}}</strong>
            </mat-hint>
            @if (formControl()?.hasError('picker')) {
            <mat-error>
                {{meta().name}} is required.
            </mat-error>
            }
        </mat-form-field>
    </div>
    <div class="aspects">
        <div class="locks" [formArray]="arrayLock!">
            @for (lock of locks; track lock._id; let i = $index) {
            @if (!!lock) {
            <mat-form-field class="form-field locked">
                <input readonly matInput [formControl]="$any($safeNavigationMigration(arrayLock?.at(i)))">
                <mat-hint><strong>{{lock?.parent?.name}} - {{lock.name}}</strong></mat-hint>
            </mat-form-field>
            }
            }
        </div>
        <div class="nodes"  [formArray]="pickerArray!">
            @for (aspect of nodes; track aspect._id; let i = $index) {
            @if (!!aspect) {
            <mat-form-field class="form-field">
                <input readonly matInput [formControl]="$any($safeNavigationMigration(pickerArray?.at(i)))">
                <button matSuffix mat-icon-button aria-label="Clear" (click)="onDelete(i)">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-hint><strong>{{aspect?.parent?.name}} - {{aspect.name}}</strong></mat-hint>
            </mat-form-field>
            }
            }
        </div>
    </div>
</div>
}
